import React from 'react';
import Icons from './Icons';

const AboutSection = () => {
  return (
    <section className="about-section" id="nosotros">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Quiénes Somos</h2>
        </div>
        
        <div className="about-content">
          <div className="about-intro">
            <p className="about-description">
              GesOps LLC es una compañía dedicada a fortalecer la confianza entre las personas y los servicios profesionales que necesitan.
            </p>
            <p className="about-description">
              Nacimos con la convicción de que toda persona merece acceder a orientación real, segura y verificable, sin temor a ser engañada o mal asesorada.
            </p>
            <p className="about-description">
              En un entorno donde la desinformación y las estafas digitales son cada vez más comunes, GesOps se posiciona como un punto de conexión confiable entre los usuarios y los profesionales certificados, ofreciendo una plataforma que promueve la transparencia, la seguridad y la credibilidad.
            </p>
          </div>

          <div className="about-purpose">
            <h3 className="about-subtitle">Nuestro Propósito</h3>
            <p className="about-description">
              Nuestro propósito es claro: velar porque cada usuario encuentre servicios legítimos y profesionales reales, dentro de un entorno donde la confianza y la ética sean el eje principal.
            </p>
            <p className="about-description">
              <strong>GesOps no es un intermediario: es un puente directo</strong> entre las personas y los profesionales confiables que pueden ayudarlas.
            </p>
          </div>

          <div className="about-grid">
            <div className="about-card">
              <div className="card-icon"><Icons.Target /></div>
              <h4 className="card-title">Misión</h4>
              <p className="card-content">
                Nuestra misión es garantizar que las personas puedan acceder a servicios profesionales auténticos, dentro de un entorno digital que promueve la transparencia, la seguridad y la eficiencia.
              </p>
            </div>

            <div className="about-card">
              <div className="card-icon"><Icons.TrendingUp /></div>
              <h4 className="card-title">Visión</h4>
              <p className="card-content">
                Ser la plataforma líder en Estados Unidos en la conexión entre personas y servicios profesionales verificados, reconocida por su compromiso con la ética, la innovación y la excelencia en la experiencia del usuario.
              </p>
            </div>
          </div>

          <div className="values-section">
            <h3 className="about-subtitle">Valores Institucionales</h3>
            <div className="values-grid">
              <div className="value-item">
                <span className="value-icon"><Icons.Eye /></span>
                <div className="value-content">
                  <h5 className="value-title">Transparencia</h5>
                  <p className="value-description">Actuamos con claridad, responsabilidad y honestidad en cada proceso y relación profesional.</p>
                </div>
              </div>
              
              <div className="value-item">
                <span className="value-icon"><Icons.Scale /></span>
                <div className="value-content">
                  <h5 className="value-title">Ética</h5>
                  <p className="value-description">Promovemos prácticas justas, legales y alineadas con la verdad.</p>
                </div>
              </div>
              
              <div className="value-item">
                <span className="value-icon"><Icons.Shield /></span>
                <div className="value-content">
                  <h5 className="value-title">Confianza</h5>
                  <p className="value-description">Validamos cada perfil y servicio para garantizar seguridad y credibilidad.</p>
                </div>
              </div>
              
              <div className="value-item">
                <span className="value-icon"><Icons.Lightbulb /></span>
                <div className="value-content">
                  <h5 className="value-title">Innovación</h5>
                  <p className="value-description">Usamos la tecnología para conectar de forma más humana y eficiente.</p>
                </div>
              </div>
              
              <div className="value-item">
                <span className="value-icon"><Icons.Heart /></span>
                <div className="value-content">
                  <h5 className="value-title">Compromiso</h5>
                  <p className="value-description">Acompañamos tanto al usuario como al profesional en su crecimiento y protección.</p>
                </div>
              </div>
              
              <div className="value-item">
                <span className="value-icon"><Icons.Award /></span>
                <div className="value-content">
                  <h5 className="value-title">Excelencia</h5>
                  <p className="value-description">Buscamos resultados medibles, consistentes y sostenibles en el tiempo.</p>
                </div>
              </div>
              
              <div className="value-item">
                <span className="value-icon"><Icons.Heart /></span>
                <div className="value-content">
                  <h5 className="value-title">Empatía</h5>
                  <p className="value-description">Entendemos la realidad de quienes buscan ayuda y respondemos con soluciones reales.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="about-commitment">
            <div className="commitment-box">
              <h3 className="commitment-title">Nuestro Compromiso es Doble y Permanente</h3>
              <div className="commitment-grid">
                <div className="commitment-item">
                  <span className="commitment-icon"><Icons.Users /></span>
                  <div className="commitment-content">
                    <h4>Con las Personas</h4>
                    <p>Ofrecerles información clara y acceso seguro a servicios legítimos.</p>
                  </div>
                </div>
                <div className="commitment-item">
                  <span className="commitment-icon"><Icons.Award /></span>
                  <div className="commitment-content">
                    <h4>Con los Profesionales</h4>
                    <p>Brindarles soluciones que impulsen su crecimiento, organización y visibilidad.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="about-footer">
            <p className="about-tagline">
              <strong>GesOps LLC: Conectamos personas con servicios reales, seguros y confiables.</strong>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
